import type { ReactNode, SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function Svg({ size = 20, children, ...rest }: IconProps & { children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...rest}
    >
      {children}
    </svg>
  );
}

export function IconWhistle(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="12" cy="13" r="7" fill="currentColor" opacity="0.9" />
      <circle cx="12" cy="13" r="2.4" fill="#0b0d12" />
      <path d="M12 6V4.5a1.5 1.5 0 0 1 1.5-1.5H19a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.5" fill="currentColor" opacity="0.7" />
    </Svg>
  );
}

export function IconFilm(p: IconProps) {
  return (
    <Svg {...p}>
      <rect x="3" y="5" width="18" height="14" rx="2.4" fill="currentColor" opacity="0.9" />
      <rect x="8" y="8" width="8" height="8" rx="1" fill="#0b0d12" opacity="0.55" />
      <path d="M5.2 7.2h1.4v1.6H5.2zm0 4h1.4v1.6H5.2zm0 4h1.4v1.6H5.2zm12.2-8h1.4v1.6h-1.4zm0 4h1.4v1.6h-1.4zm0 4h1.4v1.6h-1.4z" fill="#0b0d12" />
    </Svg>
  );
}

export function IconPlay(p: IconProps) {
  return (
    <Svg {...p}>
      <rect x="3.5" y="4" width="17" height="16" rx="3.2" fill="currentColor" opacity="0.18" />
      <path d="M10 8.2 16.2 12 10 15.8V8.2Z" fill="currentColor" />
    </Svg>
  );
}

export function IconKey(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="8" cy="12" r="4" fill="currentColor" />
      <path d="M11.5 12H21v2.2h-2V16h-2.2v-1.8H15V16h-2" fill="currentColor" opacity="0.8" />
    </Svg>
  );
}

export function IconGrid(p: IconProps) {
  return (
    <Svg {...p}>
      <rect x="3" y="3" width="8" height="8" rx="2" fill="currentColor" opacity="0.95" />
      <rect x="13" y="3" width="8" height="8" rx="2" fill="currentColor" opacity="0.55" />
      <rect x="3" y="13" width="8" height="8" rx="2" fill="currentColor" opacity="0.55" />
      <rect x="13" y="13" width="8" height="8" rx="2" fill="currentColor" opacity="0.95" />
    </Svg>
  );
}

export function IconChart(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M4 19h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <rect x="6" y="11" width="3" height="6" rx="0.8" fill="currentColor" opacity="0.55" />
      <rect x="10.5" y="7" width="3" height="10" rx="0.8" fill="currentColor" />
      <rect x="15" y="9.5" width="3" height="7.5" rx="0.8" fill="currentColor" opacity="0.7" />
    </Svg>
  );
}

export function IconBolt(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M13.2 3 6 13.2h5.2L9.6 21 18 9.6h-5.4L13.2 3Z" fill="currentColor" />
    </Svg>
  );
}

export function IconSidebar(p: IconProps) {
  return (
    <Svg {...p}>
      <rect x="3" y="4" width="18" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M9 4v16" stroke="currentColor" strokeWidth="1.8" />
    </Svg>
  );
}

export function IconUsers(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="9" cy="8.2" r="3.1" fill="currentColor" />
      <path d="M3.4 18.5c.4-3.1 2.7-5 5.6-5s5.2 1.9 5.6 5" fill="currentColor" opacity="0.9" />
      <circle cx="16.6" cy="8.8" r="2.4" fill="currentColor" opacity="0.7" />
      <path d="M15.2 18.5c.3-2.2 1.6-3.6 3.6-4.1 1.7.9 2.7 2.3 2.9 4.1" fill="currentColor" opacity="0.55" />
    </Svg>
  );
}

export function IconWire(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="2.2" fill="currentColor" />
      <path d="M8.2 8.2a5.4 5.4 0 0 0 0 7.6M15.8 8.2a5.4 5.4 0 0 1 0 7.6M5.4 5.4a9.2 9.2 0 0 0 0 13.2M18.6 5.4a9.2 9.2 0 0 1 0 13.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </Svg>
  );
}

export function IconStudio(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="3" fill="currentColor" />
      <path d="M12 3.5v2.2M12 18.3v2.2M3.5 12h2.2M18.3 12h2.2M6 6l1.6 1.6M16.4 16.4 18 18M18 6l-1.6 1.6M7.6 16.4 6 18" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </Svg>
  );
}

export function IconShare(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="7" cy="12" r="2.3" fill="currentColor" />
      <circle cx="17" cy="7" r="2.3" fill="currentColor" />
      <circle cx="17" cy="17" r="2.3" fill="currentColor" />
      <path d="m9 11 6-3M9 13l6 3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </Svg>
  );
}

export function IconSettings(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="3" fill="currentColor" />
      <path d="M12 3.8v2.1M12 18.1v2.1M3.8 12h2.1M18.1 12h2.1M6.2 6.2l1.5 1.5M16.3 16.3l1.5 1.5M17.8 6.2l-1.5 1.5M7.7 16.3l-1.5 1.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </Svg>
  );
}

export function IconGlobe(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.7" />
      <path d="M4 12h16M12 4c2.2 2.4 3.3 5.1 3.3 8S14.2 17.6 12 20c-2.2-2.4-3.3-5.1-3.3-8S9.8 6.4 12 4Z" stroke="currentColor" strokeWidth="1.6" />
    </Svg>
  );
}

export function IconLink(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M10 13.5a4 4 0 0 0 5.7.4l2.2-2.2a4 4 0 0 0-5.7-5.7L11 7.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M14 10.5a4 4 0 0 0-5.7-.4L6.1 12.3a4 4 0 0 0 5.7 5.7L13 16.8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </Svg>
  );
}

export function IconLogout(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H12v2.2H6.5a.3.3 0 0 0-.3.3v13c0 .16.14.3.3.3H12V21H6.5A2.5 2.5 0 0 1 4 18.5v-13Z" fill="currentColor" />
      <path d="M13 12h8m0 0-3-3m3 3-3 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  );
}
